var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 27H44C37.3726 27 32 32.3726 32 39V165C32 171.627 37.3726 177 44 177H140C146.627 177 152 171.627 152 165V39C152 32.3726 146.627 27 140 27Z",
    fill: "white",
    stroke: "#E5E7EB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152 27V39C152 45.6274 146.627 51 140 51H152V27Z",
    fill: "#F3F4F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152 27V39C152 45.6274 146.627 51 140 51H152",
    stroke: "#E5E7EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110 67H54C52.8954 67 52 67.8954 52 69C52 70.1046 52.8954 71 54 71H110C111.105 71 112 70.1046 112 69C112 67.8954 111.105 67 110 67Z",
    fill: "#E5E7EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130 82H54C52.8954 82 52 82.8954 52 84C52 85.1046 52.8954 86 54 86H130C131.105 86 132 85.1046 132 84C132 82.8954 131.105 82 130 82Z",
    fill: "#E5E7EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120 97H54C52.8954 97 52 97.8954 52 99C52 100.105 52.8954 101 54 101H120C121.105 101 122 100.105 122 99C122 97.8954 121.105 97 120 97Z",
    fill: "#E5E7EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115 112H54C52.8954 112 52 112.895 52 114C52 115.105 52.8954 116 54 116H115C116.105 116 117 115.105 117 114C117 112.895 116.105 112 115 112Z",
    fill: "#E5E7EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137 184C160.196 184 179 165.196 179 142C179 118.804 160.196 100 137 100C113.804 100 95 118.804 95 142C95 165.196 113.804 184 137 184Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137 177C156.33 177 172 161.33 172 142C172 122.67 156.33 107 137 107C117.67 107 102 122.67 102 142C102 161.33 117.67 177 137 177Z",
    fill: "#3B82F6",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137 177C156.33 177 172 161.33 172 142C172 122.67 156.33 107 137 107C117.67 107 102 122.67 102 142C102 161.33 117.67 177 137 177Z",
    stroke: "#3B82F6",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164 169L187 192",
    stroke: "#3B82F6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137 150C141.418 150 145 146.418 145 142C145 137.582 141.418 134 137 134C132.582 134 129 137.582 129 142C129 146.418 132.582 150 137 150Z",
    fill: "#FCD34D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImg);
export default __webpack_public_path__ + "static/media/EmptyImg.d1f8ecf779db3576214ef69f1dbab2f2.svg";
export { ForwardRef as ReactComponent };